import { mainLocator as locator } from '@core/di/main.locator';
import { CompanyStore } from '@modules/administration/pages/companies/company.store';
import { AvaliacaoTmaStore } from '@modules/health/pages/avaliacao-tma/avaliacao-tma.store';
import { PatientStore } from '@modules/health/pages/patients/patient.store';

locator.register('CompanyStore', CompanyStore);
locator.register('PatientStore', PatientStore);
locator.register('AvaliacaoTmaStore', AvaliacaoTmaStore);
